import React from "react";
import PropTypes from "prop-types";

import styles from "./loader.component.scss";

const Loader = ({rowCount = 10, colCount = 8}) => {

  const renderColumnLoader = (_, index) => (
    <div key={index} className={styles.text}>
      <span className={styles.visual}></span>
    </div>
  )

  const renderRowLoader = (_, index) => (
    <div key={index} className={styles.loader_body}>
      {[...Array(colCount)].map(renderColumnLoader)}
    </div>
  )

  return (
    <div className={styles.table_shimmer}>
      <div className={styles.shimmer_box}>
        <div className={styles.box_inside}>
          <div className={styles.table_head_shimmer}>
            <div className={styles.table_loadar}>
              <div className={styles.loader_head}>
                {[...Array(colCount)].map(renderColumnLoader)}
              </div>
              {[...Array(rowCount)].map(renderRowLoader)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Loader.propTypes = {
  rowCount: PropTypes.number,
  colCount: PropTypes.number
}

export default Loader;
